












































































import { Pracovnik } from '@/modules/administrace/pracovnik';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { Zakazka } from '@/modules/servis/zakazka';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { ERROR } from '@/main/store/actionTypes';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';

import DmsDphCalculator from '#components/dms/dphCalculator/DmsDphCalculator.vue';

import { editMutations } from '../store/types';
import { store } from '../store/edit';
import { apiProvider } from '../api';

export default PageModeMixin.extend({
	name: 'InformaceProZapujceni',
	components: {
		ZakazkaSelect: Zakazka.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		DmsDphCalculator,
	},
	props: {
		storeUri: String,
		zapujckaStav: Object,
	},
	data() {
		return {
			marks: {
				0: '0/R',
				1: '',
				2: '1/4',
				3: '',
				4: '1/2',
				5: '',
				6: '3/4',
				7: '',
				8: '1/1',
			},
		};
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers() : Record<string, string> {
			return {
				zakazka: `${this.storeUri}/${editMutations.ZAPUJCKA_ZAKAZKA_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${editMutations.ZAPUJCKA_PRACOVNIK_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${editMutations.ZAPUJCKA_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		naklStredFilter(): { ProvozovnaId: number | null } {
			return { ProvozovnaId: this.ProvozovnaId };
		},
		isZodpovosRequired(): boolean {
			return !!(this.KoPovin !== null && this.KoPovin && this.VozidlopaId);
		},
		isZakazkaSelectDisabled(): boolean {
			return this.zapujckaStav.isFakturovana || this.isViewMode;
		},
		isSlevaDisabled(): boolean {
			return !(this.zapujckaStav.isOtevrena || this.zapujckaStav.isPujcena) || this.isViewMode;
		},
		isKmStavODisabled(): boolean {
			return this.zapujckaStav.isFakturovana || this.isViewMode || !this.KmStavOdEnabled;
		},
		isPoplatekDisabled(): boolean {
			return !this.zapujckaStav.isPujcena || this.RozsirProtokol || this.isViewMode;
		},
		isZakazkaClearable(): boolean {
			return !(this.zapujckaStav.isVracena || this.zapujckaStav.isKFakturaci) && !this.isViewMode;
		},
	},
	watch: {
		DphSzbOzn(value) {
			const dphSazbaItem = this.dropdownList.DphSazba.find((dphSazba: { Value: number, Text: string }) => dphSazba.Value === value);
			if (!dphSazbaItem) {
				this.DphSazba = null;
			} else {
				const match = (dphSazbaItem as { Text: string }).Text.match(/(\d+)(%)/)!;
				this.DphSazba = match.length > 1 ? parseInt(match[1], 10) : null;
			}
		},
	},
	methods: {
		async onDlouhodobPrpChange(newValue: boolean) {
			if (newValue) {
				try {
					this.$store.commit(`${this.storeUri}/${START_LOADING}`);
					const { data: FaktpristDat } = await apiProvider.getFaktPristDatNext({ PujckaDatOd: this.PujckaDatOd! });
					this.FaktpristDat = new Date(FaktpristDat);
				} catch (err) {
					this.$store.dispatch(ERROR, { err }, { root: true });
				} finally {
					this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				}
			} else {
				this.FaktpristDat = null;
			}
		},
	},
});
